import { createClient } from '@supabase/supabase-js';
import { ENV } from '../config/env';

const supabaseUrl = ENV.VITE_SUPABASE_URL || 'https://oaknecpjdakpbaxiizte.supabase.co';
const supabaseAnonKey =
  ENV.VITE_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9ha25lY3BqZGFrcGJheGlpenRlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgxMTAzNTMsImV4cCI6MjA2MzY4NjM1M30.W9al4nH5IRkScTFGs3A9SBafbCkWZ4geMsYLg0fpBvQ';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export default supabase;
